var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarWithCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.57 1.7H21.61V0.75C21.61 0.34 21.27 0 20.86 0C20.45 0 20.11 0.34 20.11 0.75V1.7H7.89V0.75C7.89 0.34 7.55 0 7.14 0C6.73 0 6.39 0.34 6.39 0.75V1.7H3.43C1.54 1.7 0 3.23 0 5.13V20.69C0 22.58 1.54 24.12 3.43 24.12H24.57C26.46 24.12 28 22.58 28 20.69V5.13C28 3.24 26.46 1.7 24.57 1.7ZM1.5 8.09V5.13C1.5 4.07 2.37 3.2 3.43 3.2H6.39V4.61C6.39 5.02 6.73 5.36 7.14 5.36C7.55 5.36 7.89 5.02 7.89 4.61V3.2H20.11V4.61C20.11 5.02 20.45 5.36 20.86 5.36C21.27 5.36 21.61 5.02 21.61 4.61V3.2H24.57C25.63 3.2 26.5 4.07 26.5 5.13V8.09H1.5Z",
    fill: "url(#paint0_linear_2534_587)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0606 19.1416C12.8706 19.1416 12.6806 19.0716 12.5306 18.9216L9.92063 16.3116C9.63063 16.0216 9.63063 15.5416 9.92063 15.2516C10.2106 14.9616 10.6906 14.9616 10.9806 15.2516L13.0606 17.3316L17.0106 13.3816C17.3006 13.0916 17.7806 13.0916 18.0706 13.3816C18.3606 13.6716 18.3606 14.1516 18.0706 14.4416L13.5906 18.9216C13.4406 19.0716 13.2506 19.1416 13.0606 19.1416Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2534_587",
    x1: -4.17232e-7,
    y1: 24.12,
    x2: 28.9848,
    y2: 22.8719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWithCheck);
export default __webpack_public_path__ + "static/media/calendarWithCheck.7c2377023c3b2c89773e9bac48fcac7f.svg";
export { ForwardRef as ReactComponent };